import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Environment, EnvironmentService } from '@galaxy/core';
import { AccountRouteParams } from '../../core/routeparams';

// Entry the LocalEdge portal links to: websiteprodashboard.com/partnersso/:agid?token=.
// It forwards to wp-cloud-manager's partner-SSO endpoint, which verifies the JWT,
// mints the session, checks hosting, and routes to the right dashboard. Kept as a
// thin forwarder so all SSO logic lives server-side in wp-cloud-manager.
@Component({
  selector: 'app-partner-sso-forward',
  template: ``,
  standalone: false,
})
export class PartnerSsoForwardComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly environment = inject(EnvironmentService);

  ngOnInit(): void {
    const agid = (this.route.snapshot.params as AccountRouteParams).accountGroupId;
    const token = this.route.snapshot.queryParamMap.get('token') ?? '';
    window.location.assign(
      `https://${this.wpCloudManagerHost()}/wp_cloud_manager/partner-sso/${encodeURIComponent(agid)}` +
        `?token=${encodeURIComponent(token)}`,
    );
  }

  private wpCloudManagerHost(): string {
    return this.environment.getEnvironment() === Environment.PROD
      ? 'wp-cloud-manager-prod.apigateway.co'
      : 'wp-cloud-manager-demo.apigateway.co';
  }
}
